// Core component styles
const coreStyles={minHeight:'250px'};/**
* Helper method to get the styles for map component
* @param {object} contextStyles - Context styles for the map component
*/const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{...coreStyles,...contextStyles};};export default getStyles;